export { LeagueDetailScreen } from './LeagueDetailScreen';
export type { LeagueDetailScreenProps } from './LeagueDetailScreen';
